import { getDefaultAddress } from '@/api/address'
import { preview, previewOneKey } from '@/api/order'

const fetchDataHandler = (state) => {
  if (state.goodsType === 'movie') {
    return {
      show_id : state.movieInfo.show_id,
      seat_ids: state.movieInfo.seat_ids,
      goods_type: '61'
    }
  }
  return {}
}

/**
 * 获取订单预览信息
 */
export const getOrderPreview = async ({ state }) => {
  if (!state.addressId || !state.payType || !state.payInfo) {
    return Promise.reject({
      msg: '请选择支付方式和地址',
      code: 'pay_type_error'
    })
  }
  const fetchData = fetchDataHandler(state)
  console.log('fetchData', fetchData)
  const previewMap = {
    cart: () => preview({
      address_id: state.addressId,
      carts_id: `[${state.payInfo}]`
    }),
    buyNow: () => previewOneKey({
      address_id: state.addressId,
      goods_sn: state.payInfo[0],
      ...fetchData
    })
  }

  const previewFn = previewMap[state.payType]
  if (!previewFn) {
    return Promise.reject({
      msg: '不支持的支付方式',
      code: 'pay_type_error'
    })
  }

  return previewFn()
}

/**
 * 获取默认地址 ID
 */
export const getDefaultAddressId = async ({ commit }) => {
  const result = await getDefaultAddress()
  const addressInfo = result.data.data.addressInfo

  if (Object.keys(addressInfo).length !== 0) {
    commit('SET_ADDRESSID', addressInfo.address_id)
    return addressInfo.address_id
  }

  return ''
}